// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"d70a77f3","359":"442d2a73"}[chunkId] + ".chunk.css";
};